module.exports = vendors_19917fc5;